import { render, staticRenderFns } from "./IncreaseLimitDashboard.vue?vue&type=template&id=032aab9d&scoped=true&"
import script from "./IncreaseLimitDashboard.vue?vue&type=script&lang=js&"
export * from "./IncreaseLimitDashboard.vue?vue&type=script&lang=js&"
import style0 from "./IncreaseLimitDashboard.vue?vue&type=style&index=0&id=032aab9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032aab9d",
  null
  
)

export default component.exports